import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Result, Spin } from 'antd';
import { usePermissions } from 'hooks/usePermissions';
import { PERMISSION_DENIED_MESSAGE } from 'utils/errorHandling';

// ==============================|| ROUTE PERMISSION GUARD ||============================== //
// Direct URL par page kholne se pehle `view` permission check karta hai.
// Sirf retailer par lagta hai; baaki company types (wholesaler, restaurant,
// distributor, manufacturer) ke liye children seedha render hote hain.
// Usage: <RoutePermissionGuard code="sales.view"><SalesOrderList /></RoutePermissionGuard>

export default function RoutePermissionGuard({ code, anyOf, children }) {
  const { isRetailer, companyType, hasPermission, hasAnyPermission } = usePermissions();
  const [waited, setWaited] = useState(false);

  // Page refresh par permissions API se aati hain; scope load hone tak thora intezar.
  const scopeLoading = isRetailer && !companyType && !waited;
  useEffect(() => {
    if (!scopeLoading) return undefined;
    const t = setTimeout(() => setWaited(true), 4000);
    return () => clearTimeout(t);
  }, [scopeLoading]);

  if (!isRetailer) return children;

  if (scopeLoading) {
    return (
      <div style={{ padding: 48, textAlign: 'center' }}>
        <Spin />
      </div>
    );
  }

  const allowed = code ? hasPermission(code) : anyOf?.length ? hasAnyPermission(anyOf) : true;
  if (allowed) return children;

  return <Result status="403" title={PERMISSION_DENIED_MESSAGE} subTitle="You do not have access to this page." />;
}

RoutePermissionGuard.propTypes = {
  code: PropTypes.string,
  anyOf: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node
};
